<div class="rate-detail" [style.z-index]="elevation * -1 + 10">
  <div class="rate-detail__payment-method">
    <p>Tipo de pago:</p>
    <div class="rate-detail__payment-method__badge">
      <mb-icon-text>
        <mb-icon [icon]="paymentMethod.icon"></mb-icon>
        <span>{{ paymentMethod.label }}</span>
      </mb-icon-text>
    </div>
    @if (!isDisney) {
      <div class="rate-detail__payment-method__charges">
        <charges [rate]="rate"> </charges>
      </div>
    }
  </div>

  @if (!isDisney) {
    <div class="rate-detail__amenities">
      <p>Esta habitación cuenta con:</p>
      <div class="rate-detail__amenities__meal-plan">
        <mb-icon-text>
          <mb-icon [icon]="mealPlan.icon"></mb-icon>
          <span>{{ mealPlan.label }}</span>
        </mb-icon-text>
      </div>
      @if (rate.refundable) {
        <div class="rate-detail__amenities__refundable">
          <mb-icon-text>
            <mb-icon icon="check-bullet"></mb-icon>
            <span
              ><strong>Cancelación gratis,</strong> antes del
              {{ rate.free_cancel_date.plain | date: "dd 'de' MMM 'de' yyyy" }}
              inclusive.</span
            >
          </mb-icon-text>
        </div>
      } @else {
        <div class="rate-detail__amenities__refundable rate-detail__amenities__refundable--not-refundable">
          <mb-icon-text>
            <mb-icon icon="x-bullet"></mb-icon>
            <span>No podés cancelar ni realizar cambios.</span>
          </mb-icon-text>
        </div>
      }
    </div>
  } @else {
    <am-disney-combos
      [hasMealPlan]="hasMealPlans"
      [hasTickets]="hasTickets"
      [hasRoomOnlyOption]="hasRoomOnlyOption"
      [isFreeMealPlan]="isFreeMealPlan"
    >
    </am-disney-combos>
  }

  <div class="rate-detail__price">
    @if (isDisney) {
      <am-price
        [fop]="rate.payment_method.code"
        [rateSelected]="rate"
        [isDisney]="true"
        [showAmountTotal]="priceBy === 'TOTAL'"
        [quantityNights]="nights"
        [guests]="guests"
        [quantityRooms]="rooms"
      >
      </am-price>
      <button
        mb-button
        mb-button-fullwidth
        variant="principal"
        color="primary"
        (click)="bookRate()"
        [loading]="loading$ | async"
        [disabled]="rate.status === RATE_STATUS.UNAVAILABLE"
      >
        Seleccionar
      </button>
    } @else {
      <total-price
        [isMobile]="true"
        [rateInput]="rate"
        [experts]="false"
        [showAmountTotal]="priceBy"
        [priceByValue]="priceBy"
        [hotelStaticInfo]="staticInfo"
        [hotelAvailabilityInfo]="hotelAvailability$ | async"
      ></total-price>
    }
  </div>
</div>
